import { DASHBOARD_PUBS_TABS_BASE_CLASS } from "./dashboard-publications-tabs";
import React from "react";
import Tab from "atoms/tabs/tab";
import NumberBadge from "atoms/badges/number-badge";
import { t } from "utilities/localization-utils";
import Tooltip, { TooltipPlacement } from "molecules/tooltips/tooltip";

interface DashboardPublicationsTabProps {
    title: string;
    count?: number;
    disabled?: boolean;
}
const DashboardPublicationsTab = (props: DashboardPublicationsTabProps) => {
    const { title, count, disabled: isOnline } = props;
    const description = t("offline-fallback-description");
    const tooltipContent = <div>{description}</div>;
    return (
        <Tab
            cssClassName={`${DASHBOARD_PUBS_TABS_BASE_CLASS}__tab${isOnline ? "__disabled" : ""}`}
            disabled={isOnline}>
            <Tooltip
                content={tooltipContent}
                cssClassName={`${DASHBOARD_PUBS_TABS_BASE_CLASS}__tooltip`}
                disabled={!isOnline}
                hideOnClick={true}
                durationInMs={0}
                placement={TooltipPlacement.Bottom}>
                <span
                    className={`${DASHBOARD_PUBS_TABS_BASE_CLASS}__tabTitleWrapper`}>
                    <span
                        className={`${DASHBOARD_PUBS_TABS_BASE_CLASS}__title`}>
                        {title}
                    </span>
                    {count && <NumberBadge number={count} />}
                </span>
            </Tooltip>
        </Tab>
    );
};

export default DashboardPublicationsTab;
